export default __webpack_public_path__ + "static/form-button-feedback-do-0c888ba20fd68bbb465bd5918977091f7b2dc6b4b5b5376123bdbf7c1f6060c9.png";